<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    :stroke-width="weight"
    stroke-linecap="round" 
    stroke-linejoin="round" 
  >
    <line x1="4" x2="20" y1="21" y2="21"/>
    <line x1="6" x2="6" y1="17" y2="11"/>
    <line x1="10" x2="10" y1="17" y2="11"/>
    <line x1="14" x2="14" y1="17" y2="11"/>
    <line x1="18" x2="18" y1="17" y2="11"/>
    <polygon points="12 2 20 7 4 7"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconBank',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    weight: {
      type: [String, Number],
      default: 2,
    },
  },
});
</script>